const LINE_COUNT = 6;
const VIEW_WIDTH = 800;
const VIEW_HEIGHT = 120;

function buildCurvePaths() {
  return Array.from({ length: LINE_COUNT }, (_, index) => {
    const x = index * (VIEW_WIDTH / (LINE_COUNT - 1));
    const midY = VIEW_HEIGHT * 0.75;
    const endY = VIEW_HEIGHT * 0.375;
    return `M${x},0 C${x},${midY} ${VIEW_WIDTH / 2},${endY} ${VIEW_WIDTH / 2},${VIEW_HEIGHT}`;
  });
}

const curvePaths = buildCurvePaths();

export default function HubConnectorLines({ variant = "top" }) {
  const maskId = variant === "bottom" ? "home-hub-curve-mask-bottom" : "home-hub-curve-mask-top";
  const gradientId = variant === "bottom" ? "home-hub-line-gradient-bottom" : "home-hub-line-gradient-top";

  return (
    <div className={`home-hub-lines ${variant === "bottom" ? "home-hub-lines--bottom" : ""}`} aria-hidden="true">
      <svg width="100%" height={VIEW_HEIGHT} viewBox={`-10 0 820 ${VIEW_HEIGHT}`} preserveAspectRatio="none">
        <defs>
          <mask id={maskId}>
            {curvePaths.map((path, index) => (
              <path key={index} d={path} stroke="white" strokeWidth="2" fill="none" />
            ))}
          </mask>
          <linearGradient id={gradientId} x1="0" x2="0" y1={variant === "bottom" ? "1" : "0"} y2={variant === "bottom" ? "0" : "1"}>
            <stop offset="0%" stopColor="rgba(255, 255, 255, 0)" />
            <stop offset="35%" stopColor="rgba(255, 255, 255, 0)" />
            <stop offset="50%" stopColor="#ffffff" />
            <stop offset="65%" stopColor="rgba(255, 255, 255, 0)" />
            <stop offset="100%" stopColor="rgba(255, 255, 255, 0)" />
          </linearGradient>
        </defs>
        <g mask={`url(#${maskId})`}>
          <rect x="-10" y="0" width="820" height={VIEW_HEIGHT} fill="var(--home-hub-line-color, #f79839)" />
          <rect
            className={`home-hub-line-shimmer ${variant === "bottom" ? "home-hub-line-shimmer--bottom" : ""}`}
            x="-10"
            y="0"
            width="820"
            height={VIEW_HEIGHT}
            fill={`url(#${gradientId})`}
          />
        </g>
      </svg>
    </div>
  );
}
